import PropTypes from 'prop-types';
import './ActiveInactiveSwitch.scss';
import useScopedTranslation from 'hooks/useScopedTranslation';
import { activeInactiveSwitchI18n } from './i18n';

export default function ActiveInactiveSwitch({
  value,
  onChange,
  disabled = false,
  activeLabel,
  inactiveLabel,
  className = '',
}) {
  const { t } = useScopedTranslation(activeInactiveSwitchI18n);
  const resolvedActiveLabel = activeLabel ?? t('activeSwitch_active');
  const resolvedInactiveLabel = inactiveLabel ?? t('activeSwitch_inactive');
  const isActive = !!value;

  const handleClick = () => {
    if (disabled) return;
    if (typeof onChange === 'function') {
      onChange(!isActive);
    }
  };

  return (
    <button
      type='button'
      role='switch'
      aria-checked={isActive}
      className={[
        'active-inactive-switch',
        isActive ? 'is-active' : 'is-inactive',
        disabled ? 'is-disabled' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      onClick={handleClick}
      disabled={disabled}
    >
      <span className='active-inactive-switch__label'>
        {isActive ? resolvedActiveLabel : resolvedInactiveLabel}
      </span>
      <span className='active-inactive-switch__thumb' />
    </button>
  );
}

ActiveInactiveSwitch.propTypes = {
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  activeLabel: PropTypes.string,
  inactiveLabel: PropTypes.string,
  className: PropTypes.string,
};
